import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import cn from 'classnames';
import { Routes } from '../../enums/Routes';
import classes from './LogoHeader.module.css';

type LogoHeaderProps = {
  /** Viser bare merket (ikonet til venstre i logoen). */
  collapsed?: boolean;
};

export const LogoHeader = ({ collapsed = false }: LogoHeaderProps) => {
  const { t } = useTranslation();

  return (
    <Link to={Routes.Dashboard} className={cn(classes.logoLink, { [classes.collapsed]: collapsed })} aria-label={t('sidebar.logoLabel')}>
      <img src="/trustpulse-horizontal.svg" alt="" className={classes.logo} />
    </Link>
  );
};
